import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgProviderIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M12.49 8.97c.71-.94 1.13-2.1 1.13-3.37a5.606 5.606 0 0 0-11.21 0c0 1.26.41 2.42 1.12 3.35-1.31 1.83-2.03 4.28-2.03 6.3v.62h13v-.62c0-2.01-.72-4.45-2.01-6.28ZM3.66 5.6c0-2.4 1.95-4.35 4.35-4.35 2.4 0 4.36 1.95 4.36 4.35 0 .87-.26 1.69-.71 2.37-.23.36-.51.68-.84.95-.76.65-1.74 1.04-2.81 1.04S5.95 9.57 5.2 8.91c-.34-.27-.62-.59-.85-.96-.44-.68-.69-1.49-.69-2.35Zm4.35 5.67c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75Zm-5.23 3.35c.13-1.53.71-3.33 1.63-4.72.55.47 1.21.83 1.92 1.06-.21.31-.32.67-.32 1.06 0 1.1.9 2 2 2s2-.9 2-2c0-.39-.11-.75-.32-1.06.71-.23 1.35-.59 1.91-1.05.92 1.39 1.5 3.18 1.63 4.71H2.78Z",
    fill: "currentColor"
  }));
}

export { SvgProviderIcon as default };
